/**
 * const alertData
 * @const alertData.show {Boolean} 弹框显示
 * @const alertData.type {String} 弹框类型
 */
export const alertData = {
  show: false,
  type: '',
  // message 系列
  showCancelButton: true, // 是否显示取消按钮
  showConfirmButton: true, // 是否显示确定按钮
  cancelButtonText: '取消',
  cancelButtonClass:'',
  confirmButtonText: '确定',
  confirmButtonClass:'',
  messageTitle: '提示',
  messageContent: '',
  // 是否是input输入提示框
  inputData: {
    show: false, // 显示input
    length: 0, // input输入长度显示
    showLength: false, // 展示input长度
    placeholder: '' // input placeholder
  },
  // callback
  confirm: '',
  cancel: '',
  complete: ''
}
const state = () => ({
  alertData,
  sidebar: '',
  navbarAction: '',
  sidebarNum: 0, // sidebar数字小标
  has_coverletter: false, // sidebar 求职信显示
  isDouble: false, // 显示双倍会员
  updateOssOptions: {}, // oss参数
});
export default state;
